import dayjs from "dayjs";

export default {
  getBaseURL: function() {
    // testbed: https://bw-wealth-navi-api-test-evneakyd2q-an.a.run.app/api
    // production: https://bw-wealth-navi-api-evneakyd2q-an.a.run.app/api
    return "https://bw-wealth-navi-api-evneakyd2q-an.a.run.app/api";
  },
  dateFormatterWithTime: function(value) {
    if (!value) return "";
    return dayjs(value).format("DD MMM YYYY @ HH:mm");
  },
  dateFormatter: function(value) {
    if (!value) return "";
    return dayjs(value).format("DD MMM YYYY");
  },
  removeThousandSeparator: function(value) {
    return value.split(",").join("");
  },
  thousandSeparatorFormat: function(value) {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  },
  ageCalculator: function(value) {
    var NoOfDays = new Date() - new Date(value);
    return Math.floor(NoOfDays / (24 * 60 * 60 * 1000 * 365.25));
  },
  generateChildrenDummdyList: function(kids) {
    let result = [];
    kids.forEach(kid => {
      const temp = this.createChildrenDummdyData(kid);
      result.push(temp);
    });
    return result;
  },
  createChildrenDummdyData: function(kid) {
    const temp = {
      name: kid.name,
      dob: kid.dob,
      gender: kid.gender,
      sequence: kid.sequence,
      prepare_cost: null,
      plans: [
        {
          education_lv: null,
          school_name: null,
          tuition_fee: null,
          inflation: null,
          duration: null
        },
        {
          education_lv: null,
          school_name: null,
          tuition_fee: null,
          inflation: null,
          duration: null
        },
        {
          education_lv: null,
          school_name: null,
          tuition_fee: null,
          inflation: null,
          duration: null
        },
        {
          education_lv: null,
          school_name: null,
          tuition_fee: null,
          inflation: null,
          duration: null
        },
        {
          education_lv: null,
          school_name: null,
          tuition_fee: null,
          inflation: null,
          duration: null
        }
      ]
    };
    return temp;
  },
  mappingBusinessUnitById: function(businessunit_list, bu_id) {
    const found_businessunit = businessunit_list.find(
      business_unit => business_unit._id === bu_id
    );
    return found_businessunit;
  },
  mappingManagerById: function(manager_list, supervisor_id) {
    const found_supervisor = manager_list.find(
      supervisor => supervisor._id === supervisor_id
    );
    return found_supervisor;
  }
};
